export const LUCI_FLAG = 'crm.person_360'
export const ANSWER_POLL_INTERVAL_MILLIS = 2000

/** The channel Luci nudges one staff member on; keyed on the staff user, outside `thread.*`. */
export const luciChannel = (staffUserId: number) => `person360.${staffUserId}`
